import {IProductShort} from 'modules/products/types';
import React, {forwardRef, MouseEventHandler} from 'react';
import {IAnalyticsMeta, TSnippetVersion} from 'core/types';
import {TListViewType} from 'plugins/modules/listing/types';
import {ProductSnippetContainer as VerticalProductCard} from 'modules/product-snippet/components/ProductSnippetContainer';
import {IProductSnippet} from 'shared/types/productSnippet.types';

export interface IProps extends Pick<IProductSnippet, 'isCompact'> {
    listType: TListViewType;
    className?: string;
    onClick?: MouseEventHandler<HTMLDivElement>;
    analytics?: IAnalyticsMeta;
    tracking?: {
        skipOnViewTracking: boolean;
    };
    snippetVersion?: TSnippetVersion;
}

export type TCommonProductCardProps = IProps & IProductShort;

export const ProductCard = forwardRef<HTMLDivElement, TCommonProductCardProps>(function ProductCard(
    {onClick, className, analytics, tracking, snippetVersion = 'v2', isCompact = false, ...restProductCardAttr},
    ref,
) {
    return (
        <div
            className={'product-card-wrapper'}
            data-product-card-id={restProductCardAttr.id}
            onClick={onClick}
            ref={ref}
        >
            <VerticalProductCard
                className={className}
                product={restProductCardAttr}
                analyticsData={analytics}
                tracking={tracking}
                hasBorder={false}
                snippetVersion={snippetVersion}
                isCompact={isCompact}
            />
        </div>
    );
});
